/**
 * Diwali campaign window. Inclusive local dates.
 * Set enabled to false to hide the popup and fireworks without touching the header or booking form.
 * Diwali 2026 falls on 8 November.
 */
export const DIWALI_CAMPAIGN = {
  enabled: true,
  start: '2026-10-31',
  end: '2026-11-12',
  popupSessionKey: 'edt-diwali-2026-popup',
  fireworksSessionKey: 'edt-diwali-2026-fx',
};

const parseLocalDate = (iso, endOfDay) => {
  const [year, month, day] = iso.split('-').map(Number);
  if (endOfDay) return new Date(year, month - 1, day, 23, 59, 59, 999);
  return new Date(year, month - 1, day, 0, 0, 0, 0);
};

export const isDiwaliCampaignActive = (now = new Date()) => {
  if (!DIWALI_CAMPAIGN.enabled) return false;
  const start = parseLocalDate(DIWALI_CAMPAIGN.start, false);
  const end = parseLocalDate(DIWALI_CAMPAIGN.end, true);
  return now >= start && now <= end;
};

export const prefersReducedMotion = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

const readSession = (key) => {
  try {
    return window.sessionStorage.getItem(key) === '1';
  } catch (error) {
    return false;
  }
};

const writeSession = (key) => {
  try {
    window.sessionStorage.setItem(key, '1');
  } catch (error) {
    /* Private browsing can block storage. The in-memory close still hides the popup. */
  }
};

export const wasDiwaliPopupSeen = () => readSession(DIWALI_CAMPAIGN.popupSessionKey);
export const markDiwaliPopupSeen = () => writeSession(DIWALI_CAMPAIGN.popupSessionKey);
export const wasDiwaliFireworksPlayed = () => readSession(DIWALI_CAMPAIGN.fireworksSessionKey);
export const markDiwaliFireworksPlayed = () => writeSession(DIWALI_CAMPAIGN.fireworksSessionKey);

/** Skip the greeting when the visitor is already in a booking step. */
export const isBookingInProgress = () => {
  if (typeof window === 'undefined') return false;
  if (window.location.hash === '#home-booking') return true;
  if (document.querySelector('.bf-modal-backdrop, .bf-voice-dialog, .rpm-dialog')) return true;
  const active = document.activeElement;
  if (active && active.closest) {
    return Boolean(active.closest('#home-booking, #route-booking, .cbe-booking-card'));
  }
  return false;
};
